import { FC } from 'react';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { InspirationalQuote } from './InspirationalQuote';

export const TipCard: FC = () => {
    return (
        <Card padded>
            <div style={{marginBottom: 12}}>
                <Text><b>Tips &amp; Inspiration</b></Text>
            </div>

            <InspirationalQuote />
        </Card>
    );
};
